export default __webpack_public_path__ + "static/media/new_in_town.b8a2cd81.mp3";